import axios from "axios";

const TWELVE_HOURS_MS = 12 * 60 * 60 * 1000;

export const saveSession = ({ token, uid, userDetail }) => {
  if (!token) return;
  const expiresAt = Date.now() + TWELVE_HOURS_MS;

  localStorage.setItem("jwt-token", token);
  localStorage.setItem("token-expiry", String(expiresAt));

  if (uid) {
    localStorage.setItem("uid", uid);
  }

  if (userDetail) {
    localStorage.setItem("userDetail", JSON.stringify(userDetail));
  }

  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export const clearSession = () => {
  localStorage.removeItem("jwt-token");
  localStorage.removeItem("token-expiry");
  localStorage.removeItem("uid");
  localStorage.removeItem("userDetail");
  localStorage.removeItem("staffFirstName");
  localStorage.removeItem("staffId");
  localStorage.removeItem("staffPhoto");
  delete axios.defaults.headers.common.Authorization;
};

export const getRemainingSessionTime = () => {
  const expiry = Number(localStorage.getItem("token-expiry"));
  if (!expiry || Number.isNaN(expiry)) return 0;
  return expiry - Date.now();
};

export const isSessionExpired = () => getRemainingSessionTime() <= 0;

// Get the current token from localStorage
export const getToken = () => {
  if (isSessionExpired()) {
    clearSession();
    return null;
  }
  return localStorage.getItem("jwt-token");
};

// Initialize axios with token if available
export const initializeAxiosToken = () => {
  const token = getToken();
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};


